/**
 * @module components/CheckboxFacet
 */

/**
  * Used to extract content from facet data
  */
 const extractContent = ({ item }) => item.get('value');

 export default extractContent;
